/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'wafProfile';
const componentName = 'waf-profile-custom-preview';
const prefix = `${moduleName}.${componentName}`;

export const wafProfileLabel = `${prefix}.wafProfileLabel`;
export const evaluationModeStatusText = `${prefix}.evaluationModeStatusText`;

export const ENGLISH = {
    [wafProfileLabel]: 'WAF Profile',
    [evaluationModeStatusText]: 'Evaluation Mode',
};
